export { NAMESPACE, default, reducer } from "./page";
